// 3rd party
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpModule } from '@angular/http';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { PdfJsViewerModule } from 'ng2-pdfjs-viewer';

// components
import { CalibrationListComponent } from 'app/calibrations/calibration-list/calibration-list.component';
import { CustomerStatusDialogComponent } from 'app/calibrations/customer-status-dialog/customer-status-dialog.component';
import { CalibrationComponent } from 'app/calibrations/calibration/calibration.component';

// modules
import { MaterialModule } from 'app/shared/material/material.module';
import { ComponentsModule } from 'app/shared/components/components.module';

// services
import { SupplementService } from 'app/calibrations/shared/supplement.service';
import { CalibrationService } from 'app/calibrations/shared/calibration.service';

@NgModule({
  imports: [
    CommonModule,
    HttpModule,
    FormsModule,
    MaterialModule,
    RouterModule,
    ComponentsModule,
    TranslateModule,
    FlexLayoutModule,
    PdfJsViewerModule,
  ],
  exports: [
    CalibrationListComponent,
    CalibrationComponent
  ],
  declarations: [
    CalibrationListComponent,
    CustomerStatusDialogComponent,
    CalibrationComponent
  ],
  providers: [
    CalibrationService,
    SupplementService
  ],
  entryComponents: [
    CustomerStatusDialogComponent
  ]
})
export class CalibrationsModule { }



// WEBPACK FOOTER //
// ./src/app/calibrations/calibrations.module.ts